export default function RedirectToHomepage() {
    window.location.replace("https://antwargame.com/");
    return null;
}